import { ChatMessage } from '../entity';

export class ChatMessageReplyEvent {
  constructor(public message: ChatMessage) {}
}
